export const validateServicesSelectedFromDifferentIntegrations = (servicesToSave) => {
  const groups = servicesToSave.selectedServices.reduce((reduced, item) => {
    const group = reduced[item.carrierId] || [];
    group.push(item.sellerLabelProviderId);
    return {
      ...reduced,
      [item.carrierId]: [...new Set(group)],
    };
  }, {});

  return !Object.values(groups).some((group) => {
    return group.length > 1;
  });
};

// this function checks whether selected services are allowed to save or not
// true: if wallet is registered or wallet not registered, but no walleted services selected
// false: if wallet not registered and walleted services selected
export const validateServicesAgainstNotRegisteredWallet = (servicesToSave, wallets) => {
  const wallet = wallets?.[0];
  if (!wallet) return false;

  if (!wallet?.isWalletRegistered) {
    const walletServices = wallet?.resources?.sellerLabelProviderIds;

    return !servicesToSave.selectedServices.some((service) => walletServices?.includes(service.sellerLabelProviderId.toString()));
  }

  return true;
};
